import React, { Component, lazy } from 'react';
import { Switch } from 'react-router-dom';

import { RouteWrapper } from 'components/layout/helper';
import { ROUTES } from 'configs/routes/constants';
import withSuspense from 'hoc/withSuspense';

import { PAGE_VIEW_EVENTS } from '../../configs/routes/constants';

const CommunityManager = lazy(() => import('./CommunityManager'));
const CommunityHistory = lazy(() => import('./history/CommunityHistory'));

class CommunityManagerIndex extends Component {
  render() {
    return (
      <Switch>
        <RouteWrapper
          path={ROUTES.COMMUNITY.HISTORY}
          track={PAGE_VIEW_EVENTS.COMMUNITY.HISTORY}
          exact
          render={withSuspense(CommunityHistory)}
        />
        <RouteWrapper
          path={ROUTES.COMMUNITY.LIST}
          track={PAGE_VIEW_EVENTS.COMMUNITY.MAIN}
          render={withSuspense(CommunityManager)}
        />
      </Switch>
    );
  }
}

export default CommunityManagerIndex;
